import Service from "../../../Services/index";

const WaitingPayment = {
    namespaced: true,
    state: {
        waiting_payment: [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        SET_WAITING_PAYMENT: (state, res) => {
            state.waiting_payment = res.data
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        }
    },
    actions: {
        setWaitingPayment({commit},page=1) {
            return Service.WaitingPayment.getWaitingPayment(page).then(data => {
                commit("SET_WAITING_PAYMENT",data)
            })
        },
        search({commit},{page=1 ,data}){
            console.log(data);
            return Service.WaitingPayment.searchWaitingPayment(page,data).then(res=>{
                commit("SET_WAITING_PAYMENT",res);
            })
        }

    }
}

export default WaitingPayment
